import { useSession } from '@/contexts/LitSessionProvider';
import { delay } from '@/hooks/LitSessionContext/useLitAuth';
import { baseUrl } from '@/lib/misc/const';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useTheme } from 'next-themes';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useCallback, useState } from 'react';
import { toast } from 'sonner';
import Seo from '@/components/shared/Seo';
import { IoIosArrowBack } from 'react-icons/io';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import useGetLocation from '@/hooks/utilities/useGetLocation';
const MoonPayBuyWidget = dynamic(() => import('@moonpay/moonpay-react').then(mod => mod.MoonPayBuyWidget), {
  ssr: false
});
const MoonPayProvider = dynamic(() => import('@moonpay/moonpay-react').then(mod => mod.MoonPayProvider), {
  ssr: false
});
export default function MoonPayDesktop({
  setDlgOpen,
  moonpayMethod,
  amount
}) {
  const {
    PKP,
    connectedWalletAddress
  } = useSession();
  const {
    resolvedTheme: theme
  } = useTheme();
  const router = useRouter();
  const isMobile = useIsMobile();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const handleGetSignature = useCallback(async (url: string): Promise<string> => {
    const signature = await fetch(`${baseUrl}/api/moonpay`, {
      method: 'POST',
      body: JSON.stringify({
        url
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const data = await signature.json();
    console.log('moonpaydata', data);
    return data.url;
  }, []);
  const handleTransactionComplete = useCallback(async data => {
    console.log('transaction completed', data);
    LogToMixpanel({
      pkp: PKP,
      eventName: EVENTS.deposit.finalizeDeposit,
      category: CATEGORIES.deposit,
      metaData: {
        type: 'moonpay'
      }
    });
    toast('All Done!', {
      position: 'bottom-right',
      description: 'Heading back to your dashboard. Balances may take a moment to update'
    });
    await delay(2000);
    router.push('/home');
  }, [PKP, LogToMixpanel, EVENTS.deposit.finalizeDeposit, CATEGORIES.deposit, router]);
  const moonPayWidget = useMemo(() => <MoonPayProvider apiKey={process.env.NEXT_PUBLIC_MOONPAY_PUBLIC_KEY} debug>
        <MoonPayBuyWidget variant='embedded' baseCurrencyCode='SOL' currencyCode='SOL' baseCurrencyAmount={amount} style={{
      border: 'none',
      width: '100%',
      height: '775px',
      margin: '0px',
      background: 'black'
    }} defaultCurrencyCode='SOL' theme={theme === 'dark' ? 'dark' : 'light'} showAllCurrencies='false' visible paymentMethod={moonpayMethod} walletAddress={PKP?.solanaAddress} onUrlSignatureRequested={handleGetSignature} onTransactionCompleted={handleTransactionComplete} />
      </MoonPayProvider>, [theme, PKP?.solanaAddress, handleGetSignature, handleTransactionComplete]);
  useEffect(() => {
    LogToMixpanel({
      pkp: PKP,
      eventName: EVENTS.deposit.startDeposit,
      category: CATEGORIES.deposit,
      metaData: {
        type: 'moonpay'
      }
    });
  }, [PKP, LogToMixpanel, EVENTS.deposit.startDeposit, CATEGORIES.deposit]);
  return <div className='w-full overflow-x-clip flex flex-col relative items-center justify-center' data-sentry-component="MoonPayDesktop" data-sentry-source-file="MoonPayDesktop.tsx">
     
      {setDlgOpen && <div onClick={() => {
      setDlgOpen(false);
    }} className='justify-center ta-c absolute cursor-pointer left-[200px] top-[14px] text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'>
          <p>Close</p>
        </div>}
      <div className='w-[100%] mt-[-20px] flex items-center justify-center'>{moonPayWidget}</div>
    </div>;
}